import { api } from "./api";
import { AxiosError } from 'axios';
import ILoginInfo from "../interface/LoginInterfaces";
import { AuthBodyType } from "../types";
class Login {


  getLoginInfo = async (endpoint: string, body: { email: string; senha: string }): Promise<ILoginInfo | undefined> => {
    try {
      const data = await api.post("/login", { ...body });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.response);
        error.response?.data as unknown as any;
      }
    }
  };

  sendEmailReset = async (body: { login: string; lastPasswordRequired: boolean; url: string }): Promise<ILoginInfo | undefined> => {
    try {
      const data = await api.post("/login/sendEmailReset", { ...body });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
      }
    }
  };

  changePassword = async (body: AuthBodyType, login: string, password: string, sendEmail?: boolean): Promise<undefined | { message: string, success: boolean }> => {
    try {
      const data = await api.post("/login/changePassword", { 
        ...body,
        login,
        password,
        sendEmail 
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
      }
    }
  };

  resetPassword = async (body: { uid: string; password: string; lastPassword?: string }): Promise<undefined | { message: string, success: boolean }> => {
    try {
      const data: any = await api.post("/login/resetPassword", { ...body });
      return { message: data.message, success: true };
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.response);
        const message: any = error.response?.data;
        return { message: message.message, success: false };
      } else {
        return undefined;
      }
    }
  };

  logout = async (uid: string, username?: string, leaveApp?: boolean) => {
    try {
      await api.post("login/logout", { uid, username, leaveApp });
      return null;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
      }
    }
  };
}

export default Login;
